// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"ai-image-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11.5 21H3V17L9 11L13.5 15.5M8.25 3H9.75M14.25 3H15.75M3 3.75V3H3.75M21 3.75V3H20.25M3 8.75V7.5M21 8.75V7.5M3 12.75V12.5M21 12.75V12.5M17.25 8.75C17.25 9.85457 16.3546 10.75 15.25 10.75C14.1454 10.75 13.25 9.85457 13.25 8.75C13.25 7.64543 14.1454 6.75 15.25 6.75C16.3546 6.75 17.25 7.64543 17.25 8.75Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M19 16.75L19.7 18.3L21.25 19L19.7 19.7L19 21.25L18.3 19.7L16.75 19L18.3 18.3L19 16.75Z","strokeWidth":"props.strokeWidth"}}]}]};

const AiImage1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'ai-image-1',
    ref,
    icon: element,
  },
));

AiImage1Icon.displayName = 'AiImage1Icon';

export default AiImage1Icon;
